/**资源服务器支持的图片类型*/
export const isSupportedImageType = (fileType) => {
  return ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'].includes(fileType);
}
